"use strict"
exports.__esModule = true;
exports.TrendDownIconConfig = {
  name: 'TrendDownIcon',
  height: 1024,
  width: 960,
  svgPath: 'M960,864 C960,881.7 945.7,896 928,896 L480,896 C462.3,896 448,881.7 448,864 L448,800 C448,782.3 462.3,768 480,768 L741.5,768 L450.3,473.8 L343.7,580.8 C331.2,593.3 310.9,593.4 298.4,580.8 L9.4,291.8 C3.1,285.6 0,277.4 0,269.3 C0,261.1 3.1,252.9 9.4,246.7 L54.6,201.4 C60.9,195.1 69.1,192 77.3,192 C85.5,192 93.7,195.1 99.9,201.4 L320.9,422.4 L427.5,315.4 C440,302.9 460.3,302.8 472.8,315.4 L832,677.5 L831,416 C831,398.3 844.3,384 862,384 L926,384 C943.7,384 960,398.3 960,416 L960,864 Z',
  yOffset: 0,
  xOffset: 0,
};
exports.TrendDownIcon = require('../createIcon').createIcon(exports.TrendDownIconConfig);
exports["default"] = exports.TrendDownIcon;